import PropTypes from 'prop-types';
import React from "react";
import { VectorMap } from "react-jvectormap";
import { world_mill_en } from './world_mill_en';
import "./jquery-jvectormap.scss";

const map = React.createRef(null);
const Vector = props => {
  function getMaxValue(obj) {
    const values = Object.values(obj); 
    return Math.max(...values); 
  }
  return (
    <div style={{ width: props.width, height: 350 }}>
      <VectorMap
        map={'world_mill'}
        zoomOnScroll={false}
        // markers={world_mill_en}
        zoomButtons={false}
        backgroundColor="transparent"
        ref={map}
        containerStyle={{
          width: "100%",
          height: "80%",
        }}
        regionStyle={{
          initial: {
            stroke: "#9599ad",
            strokeWidth: 1,
            fill: "#f3f6f9",
            fillOpacity: 1,
          },
        }}
        series={{
          regions: [
            {
              scale: ['#f3f6f9', '#66acf2'],
              values: props.data,
              min: 0,
              max: (props.data ? getMaxValue(props.data) : 0),
              normalizeFunction: 'polynomial'
            }
          ]
        }}
        lineStyle={{
          animation: true,
          strokeDasharray: "6 3 6",
        }}
        onRegionTipShow={function (event, label, code) {
          let impression = 0;
          if (props.data && props.data[code]) {
            impression = props.data[code]
          }
          label.html(
            `<div style="background-color: white; border: 1px solid white; outline: 10px solid white; border-radius: 5px; min-height: 70px; width: 150px; color: black"; padding-left: 10px>
              <p>
                <b>${label.html()}</b>
              </p>
              <p>
                <b>Impression:</b>
                ${impression}
              </p>
            </div>`
          );
        }}
      // containerClassName="map"
      />
    </div>
  );
};

Vector.propTypes = {
  color: PropTypes.string,
  value: PropTypes.any,
  width: PropTypes.any
};

export default Vector;
